
document.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");
  new Glide('.glide').mount();

if( $('glide-video-slider').length > 0 ){
   new Glide('.glide-video-slider', {
    type: 'carousel',
    startAt: 0,
    perView: 4,
    gap: 24,
    breakpoints: {
      1300: {
        perView: 3.5
      },
      1024: {
        perView: 3
      },
      900: {
        perView: 2.5
      },
      749: {
          perView: 1.3,
          focusAt: 'center', 
      }
    }
  }).mount()
  }

  document.querySelectorAll(".play-btn_video").forEach(button => {
    button.addEventListener("click", () => {
        const videoWrapper = button.closest(".video_box");
        const videoTag = videoWrapper.querySelector(".video-items");

        // Pause all video elements
        document.querySelectorAll(".video-items").forEach(video => video.pause());

        // Toggle play/pause for the selected video
        if (videoTag) {
            if (videoTag.paused) {
                videoTag.play();
                button.style.display = "none"; // Hide button when video is playing
            } else {
                videoTag.pause();
                button.style.display = ""; // Show button when video is paused
            }
        }
    });
});

  document.querySelectorAll(".video-items").forEach(video => {
    video.addEventListener("click", () => {
        const videoWrapper = video.closest(".video_box");
        const button = videoWrapper.querySelector(".play-btn_video");

        // Pause the video and show the play button
        video.pause();
        button.style.display = ""; // Show play button when video is paused
    });
});
 
    // Listen for clicks on dynamically added .shipping-protection_switch label
$(document).on('click', '.shipping-protection_switch label', function(event) {
    event.preventDefault();
    console.log("Here");

    // Always get the checkbox fresh in case it's added dynamically
    var protectionCheckbox = $('#shipping-protection-toggle');
    var protectionVariantId = protectionCheckbox.val();

    if (protectionCheckbox.prop('checked')) {
        console.log("Here checked");
        removeProtection(protectionVariantId);
    } else {
        console.log("Here unchecked");
        addProtection(protectionVariantId);
    }
});

function addProtection(variantId) {
    console.log("addProtection");
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { quantity: 1, id: variantId },
        dataType: 'json',
        success: function() {
            // Refresh cart UI and set checkbox state
            fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates: {},
                    sections: ["cart-drawer", "cart-icon-bubble"]
                })
            })
            .then((res) => res.json())
            .then((cartData) => {
                document.querySelector("cart-drawer").renderContents(cartData);
                $('#shipping-protection-toggle').prop('checked', true); // update dynamically again
            });
        }
    });
}

function removeProtection(variantId) {
    console.log("removeProtection");
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        dataType: 'json',
        data: { updates: { [variantId]: 0 } },
        success: function() {
            // Refresh cart UI and set checkbox state
            fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates: {},
                    sections: ["cart-drawer", "cart-icon-bubble"]
                })
            })
            .then((res) => res.json())
            .then((cartData) => {
                document.querySelector("cart-drawer").renderContents(cartData);
                $('#shipping-protection-toggle').prop('checked', false); // update dynamically again
            });
        }
    });
}



  // $(document).on('click','.upsell_item-atc',function(){
  //   var id = $(this).data('id');
  //     $.ajax({
  //     type:"post",
  //     dataType: "json",
  //     url: '/cart/add.js',
  //     data:{quantity:1,id:id},
  //     success: function(data){
  //        fetch("/cart/update.js", {
  //             method: "POST",
  //             headers: {
  //                 "Content-Type": "application/json"
  //             },
  //             body: JSON.stringify({
  //                 updates: {},
  //                 sections: ["cart-drawer", "cart-icon-bubble"]
  //             })
  //         }).then((res) => res.json()).then((cartData) => {
  //             document.querySelector("cart-drawer").renderContents(cartData);
  //             document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
  //         });
  //     }
  //   });
  // });
  
});
(function() { 
var featuredReviewsSlider = function() {
  $('.reviewSlider').flickity({
    // options
    cellAlign: 'left',
    wrapAround: true,
    pageDots: false,
    prevNextButtons: true,  
    groupCells: true 
  });
};
var featuredTabs = function() {
  $('.featured_tabs_links .button').on('click',function(e){
      e.preventDefault();
      var id = $(this).attr('href');
      console.log(id);
     $('.featured_tabs_links .button').removeClass('active');
     $(this).addClass('active');
      $('.featured_tabs_content > div').hide();
      $('.featured_tabs_content '+id).show();
  })
};
var descMore = function(){
  $('.readmore-js').readmore({ 
    speed: 100, 
    collapsedHeight:315,
    heightMargin: 0,
    moreLink: '<a href="#" class="readmore-btn">more</a>',
    lessLink: '<a href="#" class="readmore-btn">less</a>' 
  });
  $('.image-with-text__readmore').readmore({ 
    speed: 100, 
    collapsedHeight:300,
    heightMargin: 0,
    moreLink: '<a href="#" class="readmore-btn">Read more</a>',
    lessLink: '<a href="#" class="readmore-btn">Read less</a>' 
  });
}
  var productQtyUpdate = function() {
    $(document).on('click','.qtyUpdate',function(e){
      e.preventDefault();
      var $qtyButton = $(e.currentTarget);
      var parent = $(this).parent();
      var $input = parent.find('input');
      var curval = parseInt(parent.find('input').val());
      if( $qtyButton.hasClass('qtyplus')){
        curval = curval + 1;
        parent.find('input').val(curval);
        $input.trigger('qtyChanged')
      }
      else if($qtyButton.hasClass('qtyminus')) {
        if( curval >= 1 ){
          curval = curval - 1;
          parent.find('input').val(curval);
           $input.trigger('qtyChanged');
        }
      }
    });
  };
featuredReviewsSlider();
featuredTabs();
descMore();
  productQtyUpdate();
 
$(document).on('shopify:section:load', function(event) {
 featuredReviewsSlider();
 featuredTabs();
 descMore();
  productQtyUpdate();

    new Glide('.glide-video-slider', {
  type: 'carousel',
  startAt: 0,
  perView: 4,
  gap: 24,
  breakpoints: {
    1300: {
      perView: 3
    },
    1024: {
      perView: 2
    },
    749: {
        perView: 1.3,
        focusAt: 'center', 
    }
  }
}).mount()
  
}); 
  
}());

// Vanilla JS listener for change event on product-info container (adjust selector if needed)
document.querySelector('product-info')?.addEventListener('change', function(e) {
  if (e.target.name === 'v') {
    let parent = e.target.closest('.addons_list_item');
    let $addonPrice = parent?.querySelector('.addon-price');
    if (!$addonPrice) return;
    
    let qty_value = parent.querySelector('input[name="mini-qty"]')?.value || 0;
    let price = e.target.dataset.price || "$0";
    
    if (Number(qty_value) > 0) {
      $addonPrice.dataset.price = price;
      $addonPrice.innerHTML = `$${(Number(price.replace('$', '')) * Number(qty_value)).toFixed(2)}`;
    } else {
      $addonPrice.dataset.price = price;
      $addonPrice.innerHTML = price;
    }
    if(e.target.value != "47411723403512"){document.querySelector('.product_note-text').style.display = 'none';}else{document.querySelector('.product_note-text').style.display = 'block';}
  }
});

// jQuery handler for custom qtyChanged event on quantity input
$(document).on('qtyChanged', 'input[name="mini-qty"]', function() {
  var $input = $(this);
  var price = document.querySelector(`#${$input.attr('id')}`).closest('.addons_list_item').querySelector('.addon-price').dataset.price || "$0";
  console.log(price,'price')
  if ($input.val() > 0) {
    var newPrice = $input.val() * Number(price.replace('$', ''));
    document.querySelector(`#${$input.attr('id')}`).closest('.addons_list_item').querySelector('.addon-price').innerHTML = ("$" + newPrice.toFixed(2));
  }
});

// product page add on js 

//Product Quantity
document.querySelector('.Quantity_box input').addEventListener('input', (e) => {
    const value = e.target.value;
    const price = document.querySelector('.addons_item_qty .addon-price').getAttribute('data-price');
    const total = Number(price.replace('$', '')) * value;
    if(value == 0){
      document.querySelector('.addons_item_qty .addon-price').innerHTML = `${price}`;
    }else{
      document.querySelector('.addons_item_qty .addon-price').innerHTML = `$${total.toFixed(2)}`;
    }
});

document.querySelector('.Quantity_box input').addEventListener('click', (e) => {
   if(e.target.value == 0){
    e.target.value = '';
   }
});


document.querySelector('.Quantity_box input').addEventListener('blur', (e) => {
  
  if (e.target.value == ''){
    e.target.value = 0;
   }
});